function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4.12046919,7.02181254 L1.75279139,3.00229326 C3.21886718,1.17205402 5.47255965,0 8,0 C10.9611294,0 13.5465048,1.60879452 14.9297424,4 L8,4 C6.12831415,4 4.55687957,5.28552849 4.12046919,7.02181254 L4.12046919,7.02181254 Z M8,15.9861216 L11.2910254,10.2858984 L11.2852357,10.2825557 C11.7358234,9.63524926 12,8.84847551 12,8 C12,6.80530747 11.4762451,5.73294445 10.6458244,5 L15.418483,5 C15.7934929,5.92643144 16,6.93909956 16,8 C16,12.418278 12.418278,16 8,16 L8,15.9861216 L8,15.9861216 Z M9.26444959,11.7960307 L6.88202913,15.9225039 C2.99299623,15.3786941 0,12.0388729 0,8 C0,6.51717799 0.403425965,5.12858116 1.10650676,3.93798065 L4.53,10 L4.53247344,9.99540267 C5.22343556,11.1935402 6.51753839,12 8,12 C8.44187976,12 8.86702447,11.9283487 9.26444959,11.7960307 L9.26444959,11.7960307 Z M8,11 C6.34314575,11 5,9.65685425 5,8 C5,6.34314575 6.34314575,5 8,5 C9.65685425,5 11,6.34314575 11,8 C11,9.65685425 9.65685425,11 8,11 Z"
});

var SvgChrome = function SvgChrome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChrome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chrome.a913604a.svg";
export { ForwardRef as ReactComponent };